module.exports = __webpack_public_path__ + "img/slider-handle-2.5e7b6f4f12914589a31f24b752cb9666.svg";